<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" fill="none" viewBox="0 0 26 24">
  <path stroke="#000" stroke-linejoin="round" d="M24.148 18.219L15.25 3.26c-1-1.68-3.499-1.68-4.498 0L1.85 18.22C.853 19.899 2.102 22 4.102 22H21.9c2 0 3.249-2.1 2.25-3.781z" clip-rule="evenodd"/>
  <path fill="#000" d="M13.75 16h-1.5V8.5h1.5V16zM13.75 18.5h-1.5V17h1.5v1.5z"/>
</svg>
